export const APP_PROMO_BANNER = 'app-promo-banner';
export const APP_PROMO_BANNER_CLOSE = 'app-promo-banner-close';
export const APP_PROMO_BANNER_OPEN = 'app-promo-banner-open';
export const APP_PROMO_BANNER_ICON = 'app-promo-banner-icon';
export const APP_PROMO_BANNER_HEIGHT = 82;
